import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Container } from '../../../../../overview/models/container';
import { DecimalPipe, NgTemplateOutlet } from '@angular/common';
import { GetAllReferencesPipe } from '../../../../pipes/get-all-references.pipe';
import { RouterLink } from '@angular/router';
import { LiveTrackingComponent } from '../../../../../../components/shipment-details/components/details/live-tracking/live-tracking.component';
import { MatDialog } from '@angular/material/dialog';
import { catchError, NEVER, Subscription, tap } from 'rxjs';
import { WindwardService } from '../../../../../../components/shipment-details/services/windward.service';
import { ContainerDetailsSkeletonComponent } from '../container-details-skeleton/container-details-skeleton.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-details',
  standalone: true,
  templateUrl: './details.component.html',
  imports: [
    ContainerDetailsSkeletonComponent,
    DecimalPipe,
    GetAllReferencesPipe,
    NgTemplateOutlet,
    RouterLink,
    MatProgressSpinner
  ],
  styleUrl: './details.component.scss'
})
export class DetailsComponent implements OnChanges, OnDestroy {
  @Input() container: Container | null = null;
  @Input() isArchived = false;

  windwardLinksLoading = false;
  customMapUrl: string = '';
  shouldOpenCustomMap = false;
  showLink = false;
  private subscription = new Subscription();

  constructor(
    private dialog: MatDialog,
    private windwardService: WindwardService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['container']) {
      this.getCustomMapLink();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  openLiveTracking(containerNo: string) {
    this.dialog.open(LiveTrackingComponent, {
      height: '900px',
      width: '1300px',
      data: { containerNo, openCustomMap: this.shouldOpenCustomMap, customMapUrl: this.customMapUrl }
    });
  }

  private getCustomMapLink() {
    if (this.gpsTrackingField()) {
      this.customMapUrl = this.gpsTrackingField()!.toString();
      this.shouldOpenCustomMap = true;
    } else if (this.isTransportModeOcean() && this.container?.shipmentNo) {
      this.windwardLinksLoading = true;
      this.subscription.add(
        this.windwardService
          .getMapLinksFor(this.container?.shipmentNo)
          .pipe(
            tap(res => {
              this.customMapUrl =
                res.find(({ containerNumber }) => this.container?.containerNo === containerNumber)?.url || '';
              this.windwardLinksLoading = false;
              this.shouldOpenCustomMap = true;
            }),
            catchError(err => {
              this.windwardLinksLoading = false;
              console.error(err);
              return NEVER;
            })
          )
          .subscribe()
      );
    }
  }

  private isTransportModeOcean() {
    return this.container?.transportMode === 'Ocean';
  }

  private gpsTrackingField() {
    return this.container?.customFields['gpsTracking'];
  }
}
